import ZEntity from '@/ZForms/parsers/entities/ZEntity.js';


export default window.ZForms.registerClass('field', class ZField extends ZEntity {
  constructor() {
    super(...arguments);
    this.attrName = null;
    this.view = null;
    this.description = null;
    this.isHidden = false;
    this.disabled = false;
    this.required = false;
    this.errorable = false;
    this.nullable = true;
    this.parentAttrName = null;
    this.parent = null;
    this.childrenFields = [];
    this.default = undefined;
  }

  async _updateParamsFromRaw(rawData) {
    await super._updateParamsFromRaw(rawData);
    this.attrName = rawData.attr_name !== undefined ? rawData.attr_name : this.attrName;
    this.view = rawData.view !== undefined ? rawData.view : this.view;
    this.description = rawData.description !== undefined ? rawData.description : this.description;
    this.isHidden = rawData.is_hidden !== undefined ? rawData.is_hidden : this.isHidden;
    this.disabled = rawData.disabled !== undefined ? rawData.disabled : this.disabled;
    this.required = rawData.required !== undefined ? rawData.required : this.required;
    this.nullable = rawData.nullable !== undefined ? rawData.nullable : this.nullable;
    this.errorable = rawData.errorable !== undefined ? rawData.errorable : this.errorable;
    this.parentAttrName = rawData.parent !== undefined ? rawData.parent : this.parentAttrName;
  }

  async _updateValuesAndErrorsFromRaw(rawData) {
    await super._updateValuesAndErrorsFromRaw(rawData);
    this.default = rawData.default === undefined ? this.default : await this.parseRawValue(rawData.default);
  }

  _defaultValueValidator(newVal) {
    if (newVal == null && !this.nullable) return 'Значение должно быть определено!';
    if ((newVal === null || newVal === undefined || newVal === '') && this.required) return 'Это обязательное поле!';
    return null;
  }

  validateValue(newVal) {
    if (this.validator != null) return this.validator(this._defaultValueValidator, newVal);
    return this._defaultValueValidator(newVal);
  }

  getPainter() {
    return markRaw(ZFieldPainter);
  }

  getDefault() {
    if (this.default == null) return null;
    return JSON.parse(JSON.stringify(this.default));
  }

  async parseRawValue(rawVal) {
    return rawVal;
  }
});
